import { Icon } from "@uzverse/ui";
import type { IconName } from "@uzverse/ui";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useAppState } from "../state/useAppState.js";
import { layoutStore } from "./layout.js";

/** The app menu as a drawer from the left (the sidebar is hidden in the immersive layout). */
export function NavDrawer() {
  const { t } = useTranslation("web");
  const { approvals } = useAppState();
  const first = useRef<HTMLAnchorElement>(null);
  const pending = Object.values(approvals).filter((a) => a.status === "pending").length;
  useEffect(() => first.current?.focus(), []);
  const items: Array<{ to: string; label: string; icon: IconName; end?: boolean; badge?: number }> =
    [
      { to: "/", label: t("nav.assistant"), icon: "chat", end: true },
      { to: "/world", label: t("nav.world"), icon: "globe" },
      { to: "/companies", label: t("nav.companies"), icon: "building" },
      { to: "/tasks", label: t("nav.tasks"), icon: "tasks" },
      { to: "/approvals", label: t("nav.approvals"), icon: "shield", badge: pending },
      { to: "/memory", label: t("nav.memory"), icon: "brain" },
      { to: "/credits", label: t("nav.credits"), icon: "cube" },
      { to: "/settings", label: t("nav.settings"), icon: "settings" },
    ];
  return (
    <aside className="world-navdrawer" data-testid="world-navdrawer" aria-label={t("nav.label")}>
      <nav className="nav">
        {items.map((item, i) => (
          <NavLink
            key={item.to}
            ref={i === 0 ? first : undefined}
            to={item.to}
            end={item.end}
            className="nav-link"
            aria-label={item.label}
            onClick={() => layoutStore.dispatch({ type: "closeNav" })}
          >
            <Icon name={item.icon} />
            <span className="nav-label">{item.label}</span>
            {item.badge ? <span className="badge">{item.badge}</span> : null}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
